import { BrowserRouter as Router } from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import React from 'react';
import { Provider } from 'react-redux';
import getTheme from '../constants/themes';
import App from './App';

const Boot = (props) => {
  const { store } = props;
  const customTheme = getTheme();
  const theme = createMuiTheme(customTheme);

  return (
    <Router>
      <Provider store={store}>
        <MuiThemeProvider theme={theme}>
          <App />
        </MuiThemeProvider>
      </Provider>
    </Router>
  );
}

export default Boot;



// WEBPACK FOOTER //
// ./src/components/Boot.js